import { useMemo } from 'react';
import { MarketplacePaymentStatePill } from 'src/components/common/MarketplacePaymentStatePill/MarketplacePaymentStatePill';
import { Content } from 'src/contexts/ContentContext';
import { Stack } from 'src/core/ui';
import { Detail } from 'src/modals/common';
import { ContentId } from 'src/utils/constants/contentId';
import { MARKETPLACE_PAYMENT_TERM_TO_CID } from 'src/utils/constants/contentIdMaps';
import {
  MarketplacePaymentState,
  MarketplacePaymentTerm,
  SaleDetails,
} from 'src/WebApiController';

import { MarketplacePaymentAdyenAction } from './MarketplacePaymentAdyenAction';

interface MarketplacePaymentTermsProps {
  marketplacePaymentTerm: MarketplacePaymentTerm | null | undefined;
  marketplacePaymentState: MarketplacePaymentState | null | undefined;
  sale?: SaleDetails | null;
}

export const MarketplacePaymentTerms = ({
  marketplacePaymentTerm,
  marketplacePaymentState,
  sale,
}: MarketplacePaymentTermsProps) => {
  const showAction = useMemo(
    () =>
      (sale?.mkpLines ?? []).some(
        (l) =>
          l.state === MarketplacePaymentState.Unpaid ||
          l.state === MarketplacePaymentState.Paid ||
          l.state === MarketplacePaymentState.PartiallyPaid
      ),
    [sale?.mkpLines]
  );

  if (sale == null || !marketplacePaymentTerm || !marketplacePaymentState) {
    return null;
  }

  return (
    <Stack width="full" justifyContent="spaceBetween">
      <Stack gap="m">
        <Detail
          label={<Content id={ContentId.MarketplaceTerms} />}
          detail={
            <Content
              id={MARKETPLACE_PAYMENT_TERM_TO_CID[marketplacePaymentTerm]}
            />
          }
        />
        <Detail
          label={<Content id={ContentId.PaymentState} />}
          detail={
            <MarketplacePaymentStatePill state={marketplacePaymentState} />
          }
        />
      </Stack>
      {showAction && <MarketplacePaymentAdyenAction sale={sale} />}
    </Stack>
  );
};
